import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '@shared/components/header/header.component';
import { FooterStepNavComponent } from '@shared/components/footer-step-nav/footer-step-nav.component';
import { LanguageSwitchComponent } from '@shared/components/language-switch/language-switch.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocationLabelComponent } from '@shared/components/location-label/location-label.component';
import { FooterLcoNavComponent } from '@shared/components/footer-lco-nav/footer-lco-nav.component';
import { MaterialModule } from '@shared/material.module';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterStepNavComponent,
    LanguageSwitchComponent,
    LocationLabelComponent,
    FooterLcoNavComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MaterialModule
  ],
  exports: [
    HeaderComponent,
    FooterStepNavComponent,
    LanguageSwitchComponent,
    LocationLabelComponent,
    FooterLcoNavComponent,
    TranslateModule,
  ]
})
export class MainSharedModule { }
